<template>
  <div class="signSuccess">您已签字成功</div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.signSuccess {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// src/views/signSuccess.vue